import React from 'react';
import NotFound from 'views/404';

const otherRoutes = { path: '*', element: <NotFound /> };

export default otherRoutes;
